import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router";
import api from "../api/api";
import { Option, Select } from "@material-tailwind/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import { countriess } from "../utils/country";
import { decrypt } from "../utils/CryptData";
   
function Profile() {
  const loginState = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();
  const [Edit, setEdit] = useState(false);
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getUserConnect = async () => {
    setIsLoading(true);
    try {
      const response = await api.get("/auths/profile", {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${JSON.parse(decrypt(localStorage.getItem("dus"))).token
            }`,
        },
      });
      setFormData(response.data.results[0]);
    } catch (error) {
      toast.error("Un problème est survenu veuiller contacter le service client");
    } finally {
      setIsLoading(false);
    }
  };

  const fields = [
    {
      label: "Nom",
      value: formData.first_name,
      type: "text",
      name: "first_name",
    },
    {
      label: "Prénom(s)",
      value: formData.last_name,
      type: "text",
      name: "last_name",
    },
    {
      label: "Email",
      value: formData.email,
      type: "email",
      name: "email",
    },
    {
      label: "Contact",
      value: formData.contact,
      type: "tel",
      name: "contact",
    },
    {
      label: "Ville",
      value: formData.city,
      type: "select",
      name: "city",
    },
    {
      label: "Adresse",
      value: formData.address,
      type: "text",
      name: "address",
    },
    {
      label: "Ancien mot de passe",
      value: formData.oldPassword,
      type: "password",
      name: "oldPassword",
    },
    {
      label: "Nouveau mot de passe",
      value: formData.password,
      type: "password",
      name: "password",
    },
  ];

  const dataUser = [
    { label: "Nom", value: formData.first_name },
    { label: "Prénom(s)", value: formData.last_name },
    { label: "Email", value: formData.email },
    { label: "Contact", value: formData.contact },
    { label: "Ville", value: formData.city },
    { label: "Adresse", value: formData.address },
  ];

  useEffect(() => {
    if (!loginState || !JSON.parse(decrypt(localStorage.getItem("dus"))).token) {
      navigate(-1);
    }
    getUserConnect();
  }, [loginState, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api.patch("/auths/profile_update", formData, {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${JSON.parse(decrypt(localStorage.getItem("dus"))).token
            }`,
        },
      });
      setEdit(!Edit);
      toast.success("Votre profil a été mis à jour avec succès");
    } catch (error) {
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    // <div className="py-10 bg-gray-100 dark:bg-gray-900">
    <div className="max-w-6xl mx-auto my-10 flex flex-col lg:flex-row gap-4 p-4">
      <div className="lg:w-3/4 w-full mx-auto bg-white p-6 rounded-xl ">
        <h1 className="text-2xl lg:text-3xl font-serif font-extrabold mb-4 text-gray-900 dark:text-white">
          Profile
        </h1>

        <div className="w-full h-56 rounded-sm p-5 bg-[url('/public/Shoppig.gif')] bg-center bg-no-repeat">
          <svg className="w-36 h-36 rounded-full bg-blue-300/20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" /></svg>

          {/* <div
            className="w-36 h-36 bg-blue-300/20 rounded-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NzEyNjZ8MHwxfHNlYXJjaHw4fHxwcm9maWxlfGVufDB8MHx8fDE3MTEwMDM0MjN8MA&ixlib=rb-4.0.3&q=80&w=1080')",
            }}
          ></div> */}
        </div>
        <div className="divider"></div>

        {isLoading ? (
          <div className="animate-pulse">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 px-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="mb-4">
                  <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
                  <div className="h-6 bg-gray-100 rounded w-3/4"></div>
                </div>
              ))}
            </div>
          </div>
        ) : !Edit ? (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 px-4">
              {dataUser.map(({ label, value }, index) => (
                <div key={index} className="mb-4">
                  <div className="text-md font-bold mb-2 text-gray-700 dark:text-blue">
                    {label}
                  </div>
                  <div className="font-semibold text-gray-900 dark:text-gray-300">
                    {value}
                  </div>
                </div>
              ))}
            </div>

            <div className="w-1/3 mx-auto mt-4">
              <button
                type="button"
                onClick={() => setEdit(!Edit)}
                className="w-full p-4 bg-black text-white rounded-lg text-lg font-semibold hover:bg-gray-800 flex items-center justify-center gap-2"
              >
                Modifier
                <PencilSquareIcon className="h-5 w-5" />
              </button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 px-4">
              {fields.map(({ label, value, type, name }, index) => (
                <div key={index} className="mb-4">
                  <label className="block mb-2 text-gray-700 dark:text-gray-300">
                    {label}
                  </label>
                  {type === "select" ? (
                    <Select
                      id={name}
                      name={name}
                      className="w-full py-2 border-2 rounded-lg dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                      value={value}
                      onChange={(e) => setFormData({ ...formData, [name]: e })}
                    >
                      {countriess.map((item, index) => (
                              <Option key={index} value={item.capital}>
                                {item.capital}
                              </Option>
                            ))}
                    </Select>
                  ) : (
                    <input
                      type={type}
                      name={name}
                      defaultValue={value}
                      onChange={(e) =>
                        setFormData({ ...formData, [name]: e.target.value })
                      }
                      className="p-4 w-full border-2 rounded-lg dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                      placeholder={label}
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="flex justify-center mt-4 pt-8 border-t-2 gap-10">
              <button
                onClick={() => setEdit(!Edit)}
                className="w-1/4  btn btn-outline text-black  text-md font-semibold "
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-1/3 btn bg-black text-white text-lg font-semibold hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isSubmitting && (
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                )}
                {isSubmitting ? "Mise à jour..." : "Soumettre"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
    // </div>
  );
}

export default Profile;
